import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { SnackDelete_SnackListPage_Mutation } from "./mutation";
import { SnackList_SnackListPage_Query } from "../../query/use-snack-list-query/query";

type Props = {
	hotelID: string;
};

export const useSnackDeleteMutation = ({ hotelID }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(SnackDelete_SnackListPage_Mutation, {
		refetchQueries: [
			{
				query: SnackList_SnackListPage_Query,
				variables: {
					hotelID,
				},
			},
		],
	});

	const onDelete = useCallback(
		async ({ uuid, title }: { uuid: string; title: string }) => {
			if (!window.confirm("本当に削除しますか？")) return;

			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					hotelID,
					uuid,
				},
			}).finally(() => hideLoadingScreenCallback());

			if (!errors) {
				notifyUserEventInfo({
					title: `スナック（${title}）を削除しました`,
				});
			}
		},
		[hideLoadingScreenCallback, hotelID, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDelete,
	};
};
